import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { selectClientLensFormId } from "redux/slices/clientLens";
import { useAppSelector } from "redux/hooks";
import { ImportToProfileDialog } from "../ImportToProfileDialog";

function LensProfileImportDialog({ onClose }: { onClose: () => void }) {
  const formId = useAppSelector(selectClientLensFormId);

  return (
    <Dialog open={true} fullWidth maxWidth="md">
      <DialogTitle>Import to Profile</DialogTitle>
      <DialogContent>
        <ImportToProfileDialog formId={formId} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}

export default LensProfileImportDialog;
